import { translate } from "app/filters/i18nFilter";
import { AVAILABLE_AGES, SELECT_ALL_AGES } from "app/UtilitiesAndConstants/Constants/age";
import type { IAgeBucketIDs, IAgeBucketID } from "app/UtilitiesAndConstants/types/age";
import type { IItems } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/tableTop/Filters/types";

export const items: IItems<IAgeBucketID> = [
    {
        id: SELECT_ALL_AGES,
        textKey: "demographics.user.based.compare.table.filters.age.all",
    },
    ...AVAILABLE_AGES.map(({ id, text }) => {
        return { id, textKey: text };
    }),
];

export const getOptions = (disableAllBucket) => {
    const options = items.map((item) => {
        const { id, textKey } = item;
        const disabled = id === SELECT_ALL_AGES && disableAllBucket;
        return {
            id,
            text: translate(textKey),
            disabledTooltip: translate("demographics.user.based.compare.table.filters.age.disable"),
            disabled,
        };
    });
    return options;
};

export const getInitialSelectedItems = (ageBucketIDs: IAgeBucketIDs): Record<string, boolean> => {
    return ageBucketIDs.reduce((accumulatedSelectedItems, ageBucketID) => {
        return {
            ...accumulatedSelectedItems,
            [ageBucketID]: true,
        };
    }, {});
};
